// import React, { useEffect, useState } from "react";
// import ReviewModal from "./ReviewModal";
// import img1 from '../../assets/images/EmailSubscripe/EmailSubscripeImg1.png'
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { Star } from "lucide-react";

// const IconWrapper = ({ children, active, completed }) => (
//   <div className="relative flex items-center justify-center">
//     {/* PULSE RING */}
//     {active && (
//       <span
//         className="absolute w-11 h-11 rounded-full bg-[#007BFF]/20 animate-ping"
//       />
//     )}

//     <div
//       className={`
//         w-10 h-10 rounded-full flex items-center justify-center
//         transition-all duration-300
//         ${
//           completed
//             ? "bg-[#007BFF] shadow-md"
//             : active
//             ? "border-2 border-[#007BFF] bg-white"
//             : "border-2 border-[#D0DBFF] bg-white"
//         }
//       `}
//     >
//       {children}
//     </div>
//   </div>
// );



// // const OrderPlacedSVG = ({ active }) => (
// //   <svg
// //     width="28"
// //     height="28"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke={active ? "#007BFF" : "#B5CAFF"}
// //     strokeWidth="2"
// //     strokeLinecap="round"
// //     strokeLinejoin="round"
// //   >
// //     <rect x="5" y="3" width="14" height="18" rx="2" />
// //     <path d="M9 3v4h6V3" />
// //     <polyline points="9 14 11 16 15 12" />
// //   </svg>
// // );

// // const PackagingSVG = ({ active }) => (
// //   <svg
// //     width="28"
// //     height="28"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke={active ? "#007BFF" : "#B5CAFF"}
// //     strokeWidth="2"
// //     strokeLinecap="round"
// //     strokeLinejoin="round"
// //   >
// //     <path d="M3 7l9 5 9-5" />
// //     <path d="M3 7v10l9 5 9-5V7" />
// //     <path d="M12 12v10" />
// //   </svg>
// // );

// // const OnRoadSVG = ({ active }) => (
// //   <svg
// //     width="28"
// //     height="28"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke={active ? "#007BFF" : "#B5CAFF"}
// //     strokeWidth="2"
// //     strokeLinecap="round"
// //     strokeLinejoin="round"
// //   >
// //     <rect x="1" y="6" width="15" height="11" rx="2" />
// //     <path d="M16 8h4l3 3v6h-7" />
// //     <circle cx="5.5" cy="18" r="1.5" />
// //     <circle cx="18.5" cy="18" r="1.5" />
// //   </svg>
// // );

// // const DeliveredSVG = ({ active }) => (
// //   <svg
// //     width="28"
// //     height="28"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke={active ? "#007BFF" : "#B5CAFF"}
// //     strokeWidth="2"
// //     strokeLinecap="round"
// //     strokeLinejoin="round"
// //   >
// //     <path d="M3 10l9-7 9 7" />
// //     <path d="M9 22V12h6v10" />
// //     <polyline points="9 17 11 19 15 15" />
// //   </svg>
// // );

// // const orderSteps = [
// //   { key: "placed", label: "Order Placed", icon: OrderPlacedSVG, done: true },
// //   { key: "packaging", label: "Packaging", icon: PackagingSVG, done: true },
// //   { key: "road", label: "On The Road", icon: OnRoadSVG, done: false },
// //   { key: "delivered", label: "Delivered", icon: DeliveredSVG, done: false },
// // ];

// const OrderPlacedIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="2"
//       />
//       <path
//         d="M9 12l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const PackagingIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7l9 5 9-5-9-4-9 4z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M3 7v10l9 5 9-5V7"
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//     </svg>
//   </IconWrapper>
// );


// const OnTheRoadIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7h11v7H3z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="1"
//       />
//       <path
//         d="M14 9h4l3 3v2h-7z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//       <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//     </svg>
//   </IconWrapper>
// );


// const DeliveredIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M9 16l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const orderSteps = [
//   { key: "placed", label: "Order Placed", icon: OrderPlacedIcon, done: true },
//   { key: "packaging", label: "Packaging", icon: PackagingIcon, done: true },
//   { key: "road", label: "On The Road", icon: OnTheRoadIcon, done: false },
//   { key: "delivered", label: "Delivered", icon: DeliveredIcon, done: false },
// ];

// const orderActivities = [
//   {
//     text: "Your order has been delivered. Thank you for shopping at Clicon!",
//     time: "23 Jan, 2021 at 7:32 PM",
//     success: true,
//   },
//   {
//     text: "Our delivery man (John Wick) has picked-up your order for delivery.",
//     time: "23 Jan, 2021 at 2:00 PM",
//   },
//   {
//     text: "Your order has reached at last mile hub.",
//     time: "22 Jan, 2021 at 8:00 AM",
//   },
// ];

// /* ===================== SMALL COMPONENTS ===================== */


// const Row = ({ label, value, bold, green }) => (
//   <div className={`flex justify-between ${bold ? "font-semibold" : ""}`}>
//     <span className={green ? "text-green-600" : ""}>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* ===================== TRACKER ===================== */

// const OrderTracker = () => {
// const completedIndex = orderSteps.findLastIndex(s => s.done);
//   return (
//     <div className="rounded-xl p-6">
//       <p className="text-xs text-gray-500 mb-6">
//         Order expected arrival <span className="text-[#191C1F] font-medium">23 Jan, 2021</span>
//       </p>

//       {/* TRACK BAR */}
//       <div className="relative px-6 mb-12">
//         {/* BASE LINE */}
//         <div className="absolute -top-0.5 left-[calc(12.5%)] right-[calc(12.5%)] h-[3px] bg-white" />

//         {/* PROGRESS LINE */}
//         <div
//           className="absolute -top-0.5 left-[calc(12.5%)]  h-[4px] bg-[#007BFF] rounded-full"
//           style={{
//             left: "12.5%",
//             width: `${(completedIndex / (orderSteps.length - 1)) * 75}%`,
//           }}
//         />

//         {/* DOTS */}
//         <div className="absolute left-[calc(10%)] right-[calc(10%)] inset-0 flex justify-between items-center">
//           {orderSteps.map((step, i) => (
// <div
//   key={step.key}
//   className={`
//     w-5 h-5 rounded-full
//     flex items-center justify-center
//     transition-all duration-700 ease-in-out
//     ${
//       step.done
//         ? "bg-[#007BFF]"
//         : "border-2 border-[#007BFF] bg-white"
//     }
//   `}
// >
//   {step.done && (
//     <svg
//       viewBox="0 0 24 24"
//       className="w-3 h-3 text-white"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="3"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="20 6 9 17 4 12" />
//     </svg>
//   )}
// </div>

//           ))}
//         </div>
//       </div>

// {/* ICONS + LABELS */}
// {/* <div className="grid grid-cols-4 text-center gap-4">
//   {orderSteps.map((step, index) => {
//     const Icon = step.icon;
//     const isCompleted = index < completedIndex;
//     const isActive = index === completedIndex;
//     const isUpcoming = index > completedIndex;

//     return (
//       <div
//         key={step.key}
//         className="flex flex-col items-center gap-2"
//       >

//         <div className="flex items-center justify-center">
//           <Icon active={isCompleted || isActive} />
//         </div>


//         <p
//           className={`text-xs ${
//             isUpcoming ? "text-gray-400" : "text-gray-700"
//           }`}
//         >
//           {step.label}
//         </p>
//       </div>
//     );
//   })}
// </div> */}
// <div className="grid grid-cols-4 text-center gap-4">
//   {orderSteps.map((step, index) => {
//     const Icon = step.icon;

//     const isCompleted = index < completedIndex;
//     const isActive = index === completedIndex;
//     const isUpcoming = index > completedIndex;

//     return (
//       <div
//         key={step.key}
//         className="flex flex-col items-center gap-2"
//       >
//         {/* ICON */}
//         <div className="flex items-center justify-center">
//           <Icon
//             completed={isCompleted}
//             active={isActive}
//           />
//         </div>

//         {/* LABEL */}
//         <p
//           className={`text-xs ${
//             isUpcoming ? "text-gray-400" : "text-gray-700"
//           }`}
//         >
//           {step.label}
//         </p>
//       </div>
//     );
//   })}
// </div>

//     </div>
//   );
// };

// /* ===================== ACTIVITY ===================== */

// const OrderActivity = () => (
//   <div className="bg-white rounded-md border border-[#E4E7E9] p-6">
//     <h3 className="text-base font-semibold mb-4">Order Activity</h3>

//     <div className="space-y-4">
//       {orderActivities.map((a, i) => (
//         <div key={i} className="flex gap-4">
//           <div
//             className={`w-9 h-9 rounded-md flex items-center justify-center ${
//               a.success
//                 ? "bg-green-100 text-green-600"
//                 : "bg-blue-100 text-blue-600"
//             }`}
//           >
//             ✓
//           </div>

//           <div>
//             <p className="text-sm">{a.text}</p>
//             <p className="text-xs text-gray-500 mt-1">{a.time}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// /* ===================== PAGE ===================== */

// const OrderDetailsPage = () => {
//   const [openReview, setOpenReview] = useState(false);
//   const [myReview, setMyReview] = useState(null);
//   const [previewImage, setPreviewImage] = useState(null);
//   const hasImages = myReview?.images?.length > 0;

//   const productId = "6957b20ee988c642af3ae885"

//     const fetchMyReview = async () => {
//       const res = await api({
//         method: SummaryApi.getMyReview.method,
//         url: SummaryApi.getMyReview.url(productId),
//       });

//       if (res.data.success) {
//         setMyReview(res.data.review); // null or review object
//       }
//     };

//     useEffect(() => {
//       fetchMyReview();
//     }, []);

//   return (
//     <div className="">
//     <div className="">
//       <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6">

//         {/* LEFT */}
//         <div className="space-y-6">
//           {/* HEADER CARD */}
//           <div className="bg-white border border-[#B5CAFF] rounded-md p-4 flex items-center justify-between">
//             <div>
//               <p className="text-sm font-medium text-[#191C1F]">#96459761</p>
//               <p className="text-xs text-[#475156]">
//                 4 Products · Order Placed in 17 Jan, 2021 at 7:32 PM
//               </p>
//             </div>

//             <div className="text-[#007BFF] font-bold text-lg md:text-xl">
//               ₹1199.00
//             </div>

//             <img
//               src={img1}
//               className="w-12 h-12 rounded border-2 border-[#B5CAFF] object-cover"
//               alt=""
//             />
//           </div>

//           <OrderTracker />
//           <OrderActivity />
//         </div>

//         {/* RIGHT */}
//         <div className="space-y-6">
//           <div className="bg-white rounded-md border border-[#E4E7E9] p-4">
//             <h3 className="text-base font-semibold mb-2">Shipping details</h3>
//               <hr />
//             <p className="text-sm leading-6 mt-2">
//               Dhano Balan<br />
//               Plot no 12, Victory fields, thalapetti, madhavaram<br />
//               CHENNAI, TAMIL NADU 600060, India<br />
//               Phone number: 6369999874
//             </p>
//           </div>

//           <div className="bg-white rounded-md border border-[#E4E7E9] px-4 pt-4 pb-4 lg:pb-16">
//             <h3 className="text-base font-semibold mb-3">Order Summary</h3>
//             <div className="space-y-2 text-sm">
//               <Row label="Subtotal (3 items)" value="₹234" />
//               <Row label="Discount" value="-₹28" />
//               <Row label="Tax" value="₹15" />
//               <Row label="Delivery" value="Free" green />
//               <hr />
//               <Row label="Total" value="₹221" bold />
//             </div>
//           </div>
//         </div>
//       </div>

//     </div>
//     {/* <div className="mt-8 flex justify-center">
//     <button
//         onClick={() => setOpenReview(true)}
//         className="
//         w-full 
//         sm:w-auto 
//         px-8
//         bg-[#007BFF] 
//         text-white 
//         py-2 
//         rounded-md 
//         text-sm 
//         font-medium
//         "
//     >
//         Add Review & comments
//     </button>
//     </div> */}
//     <div className="mt-8 flex justify-center">
//       {!myReview ? (
//         <button
//           onClick={() => setOpenReview(true)}
//           className="px-8 bg-[#007BFF] text-white py-2 rounded-md text-sm font-medium"
//         >
//           Add Review & comments
//         </button>
//       ) : (
//       <div className="w-full bg-white border-[#E4E7E9] max-w-4xl border rounded-md p-4">

//         {/* HEADER ROW */}
//         <div className="flex items-center justify-between mb-3">
//           <p className="font-medium">Your Review</p>

//           {/* TOP EDIT BUTTON (NO IMAGE CASE) */}
//           {!hasImages && (
//             <button
//               onClick={() => setOpenReview(true)}
//               className="text-sm text-[#007BFF] font-medium"
//             >
//               Edit Review
//             </button>
//           )}
//         </div>

//         {/* CONTENT ROW */}
//         <div className="flex gap-4">

//           {/* LEFT : STAR + COMMENT */}
//           <div className="flex-1">
//             {/* STAR RATING */}
//             <div className="flex gap-1">
//               {[1, 2, 3, 4, 5].map((i) => (
//                 <Star
//                   key={i}
//                   size={16}
//                   className={
//                     i <= myReview.rating
//                       ? "fill-[#FA8232] text-[#FA8232]"
//                       : "text-gray-300"
//                   }
//                 />
//               ))}
//             </div>

//             {/* COMMENT */}
//             <p className="text-sm text-gray-600 mt-2 leading-relaxed">
//               {myReview.comment}
//             </p>
//           </div>

//           {/* RIGHT : IMAGES */}
//           {hasImages && (
//             <div className="flex gap-2">
//               {myReview.images.map((img, idx) => (
//                 <img
//                   key={idx}
//                   src={img}
//                   alt="review"
//                   onClick={() => setPreviewImage(img)}
//                   className="
//                     w-16 h-16 object-cover rounded-md border
//                     cursor-pointer hover:opacity-80
//                   "
//                 />
//               ))}
//             </div>
//           )}
//         </div>

//         {/* IMAGE PREVIEW MODAL */}
//         {previewImage && (
//           <div
//             className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div className="relative">
//               <img
//                 src={previewImage}
//                 alt="preview"
//                 className="max-w-[90vw] max-h-[90vh] rounded-lg"
//               />
//               <button
//                 onClick={() => setPreviewImage(null)}
//                 className="absolute -top-4 -right-4 bg-white rounded-full p-1"
//               >
//                 ✕
//               </button>
//             </div>
//           </div>
//         )}

//         {/* BOTTOM EDIT BUTTON (IMAGE CASE) */}
//         {hasImages && (
//           <div className="mt-4 flex justify-end">
//             <button
//               onClick={() => setOpenReview(true)}
//               className="text-sm text-[#007BFF] font-medium"
//             >
//               Edit Review
//             </button>
//           </div>
//         )}
//       </div>
//       )}
//     </div>
//     <ReviewModal
//       open={openReview}
//       onClose={() => {
//         setOpenReview(false);
//         fetchMyReview(); // refresh after submit
//       }}
//       productId={productId}
//       existingReview={myReview}
//     />
//     </div>
//   );
// };

// export default OrderDetailsPage;


// import React, { useCallback, useEffect, useState } from "react";
// import ReviewModal from "./ReviewModal";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { useParams } from "react-router-dom";
// import { X } from "lucide-react";
// import Breadcrumb from "../BreadCrumb"; 

// const formatOrderDate = (dateString) => {
//   const date = new Date(dateString);

//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, "0");

//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   hours = String(hours).padStart(2, "0");

//   return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
// };



// const getCompletedIndex = (status) => {
//   switch (status) {
//     case "ordered":
//       return 0;

//     case "packaged":
//       return 1;

//     case "shipped":
//       return 2;

//     case "delivered":
//     case "returnRequested":
//     case "returnAccepted":
//     case "returned":
//       // 🔴 Return flow delivered-ku apram varum
//       return 3;

//     case "cancelled":
//       // cancelled → order placed stage-la stop
//       return 0;

//     default:
//       return 0;
//   }
// };

// const IconWrapper = ({ children, active, completed }) => (
//   <div className="relative flex items-center justify-center">
//     {/* PULSE RING */}
//     {active && (
//       <span
//         className="absolute w-11 h-11 rounded-full bg-[#007BFF]/20 animate-ping"
//       />
//     )}

//     <div
//       className={`
//         w-10 h-10 rounded-full flex items-center justify-center
//         transition-all duration-300
//         ${completed
//           ? "bg-[#007BFF] shadow-md"
//           : active
//             ? "border-2 border-[#007BFF] bg-white"
//             : "border-2 border-[#D0DBFF] bg-white"
//         }
//       `}
//     >
//       {children}
//     </div>
//   </div>
// );

// const OrderPlacedIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="2"
//       />
//       <path
//         d="M9 12l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const PackagingIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7l9 5 9-5-9-4-9 4z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M3 7v10l9 5 9-5V7"
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//     </svg>
//   </IconWrapper>
// );


// const OnTheRoadIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7h11v7H3z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="1"
//       />
//       <path
//         d="M14 9h4l3 3v2h-7z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//       <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//     </svg>
//   </IconWrapper>
// );


// const DeliveredIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M9 16l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const orderSteps = [
//   { key: "ordered", label: "Order Placed", icon: OrderPlacedIcon },
//   { key: "packaged", label: "Packaging", icon: PackagingIcon },
//   { key: "shipped", label: "Shipped", icon: OnTheRoadIcon },
//   { key: "delivered", label: "Delivered", icon: DeliveredIcon },
// ];


// const orderActivities = [
//   {
//     text: "Your order has been delivered. Thank you for shopping at Clicon!",
//     time: "23 Jan, 2021 at 7:32 PM",
//     success: true,
//   },
//   {
//     text: "Our delivery man (John Wick) has picked-up your order for delivery.",
//     time: "23 Jan, 2021 at 2:00 PM",
//   },
//   {
//     text: "Your order has reached at last mile hub.",
//     time: "22 Jan, 2021 at 8:00 AM",
//   },
// ];

// /* ===================== SMALL COMPONENTS ===================== */


// const Row = ({ label, value, bold, green }) => (
//   <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
//     <span className={green ? "text-green-600" : ""}>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* ===================== TRACKER ===================== */

// const OrderTracker = ({ status }) => {
//   const completedIndex = getCompletedIndex(status);
//   return (
//     <div className="rounded-xl mt-6">
//     <h3 className="text-base md:text-lg px-2 font-semibold mb-4">Order Tracking</h3>
//     <div className="rounded-xl p-6 mt-6">

//       {/* <p className="text-xs text-gray-500 mb-6">
//         Order expected arrival <span className="text-[#191C1F] font-medium">23 Jan, 2021</span>
//       </p> */}

//       {/* TRACK BAR */}
//       <div className="relative px-6 mb-12">
//         {/* BASE LINE */}
//         <div className="absolute -top-0.5 left-[calc(12.5%)] right-[calc(12.5%)] h-[3px] bg-white" />

//         {/* PROGRESS LINE */}
//         <div
//           className="absolute -top-0.5 left-[calc(12.5%)]  h-[4px] bg-[#007BFF] rounded-full"
//           style={{
//             left: "12.5%",
//             width: `${(completedIndex / (orderSteps.length - 1)) * 75}%`,
//           }}
//         />

//         {/* DOTS */}
//         <div className="absolute left-[calc(11%)] right-[calc(11%)] inset-0 flex justify-between items-center">
// {orderSteps.map((step, i) => {
//   const isDone = i <= completedIndex;

//   return (
//     <div
//       key={step.key}
//       className={`
//         w-5 h-5 rounded-full
//         flex items-center justify-center
//         transition-all duration-700 ease-in-out
//         ${isDone
//           ? "bg-[#007BFF]"
//           : "border-2 border-[#007BFF] bg-white"
//         }
//       `}
//     >
//       {isDone && (
//         <svg
//           viewBox="0 0 24 24"
//           className="w-3 h-3 text-white"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="3"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <polyline points="20 6 9 17 4 12" />
//         </svg>
//       )}
//     </div>
//   );
// })}

//         </div>
//       </div>

//       <div className="grid grid-cols-4 text-center gap-4">
//         {orderSteps.map((step, index) => {
//           const Icon = step.icon;

//           const isCompleted = index < completedIndex;
//           const isActive = index === completedIndex;
//           const isUpcoming = index > completedIndex;

//           return (
//             <div
//               key={step.key}
//               className="flex flex-col items-center gap-2"
//             >
//               {/* ICON */}
//               <div className="flex items-center justify-center">
//                 <Icon
//                   completed={isCompleted}
//                   active={isActive}
//                 />
//               </div>

//               {/* LABEL */}
//               <p
//                 className={`text-xs ${isUpcoming ? "text-gray-400" : "text-gray-700"
//                   }`}
//               >
//                 {step.label}
//               </p>
//             </div>
//           );
//         })}
//       </div>

//     </div>
//     </div>
//   );
// };

// /* ===================== ACTIVITY ===================== */

// const OrderActivity = () => (
//   <div className="bg-white rounded-md border border-[#E4E7E9] p-6">
//     <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

//     <div className="space-y-4">
//       {orderActivities.map((a, i) => (
//         <div key={i} className="flex gap-4">
//           <div
//             className={`w-9 h-9 rounded-md flex items-center justify-center ${a.success
//                 ? "bg-green-100 text-green-600"
//                 : "bg-blue-100 text-blue-600"
//               }`}
//           >
//             ✓
//           </div>

//           <div>
//             <p className="text-sm">{a.text}</p>
//             <p className="text-xs text-gray-500 mt-1">{a.time}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// /* ===================== PAGE ===================== */


// const OrderDetailsPage = () => {
//   const [openReview, setOpenReview] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [reviewsMap, setReviewsMap] = useState({}); // productId -> review
//   const [reviewFetchedMap, setReviewFetchedMap] = useState({});

//   const { orderId } = useParams();
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     const res = await api({
//       method: SummaryApi.getOrderById.method,
//       url: SummaryApi.getOrderById.url(orderId),
//     });

//     if (res.data.success) {
//       setOrder(res.data.order);
//     }
//     setLoading(false);
//   }, [orderId]);

//   useEffect(() => {
//     fetchOrder();
//   }, [fetchOrder]);

//   const fetchMyReview = useCallback(async (productId) => {
//     if (!productId || reviewFetchedMap[productId]) return;

//     try {
//       const res = await api({
//         method: SummaryApi.getMyReview.method,
//         url: SummaryApi.getMyReview.url(productId),
//       });

//       setReviewsMap(prev => ({
//         ...prev,
//         [productId]: res.data.success ? res.data.review : null,
//       }));

//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));

//     } catch (err) {
//       console.error("Fetch review error:", err);
//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));
//     }
//   }, [reviewFetchedMap]);

//   useEffect(() => {
//     if (!order) return;

//     order.items.forEach(item => {
//       fetchMyReview(item.productId._id);
//     });
//   }, [order, fetchMyReview]);

//   const breadcrumbItems = [
//     { label: "Home", path: "/" },
//     { label: "My Orders", path: "/my-account/my-orders" },
//     { label: `#${order?._id?.slice(-8)}` }, // current page – no path
//   ];

//   if (loading) {
//     return <p className="text-center mt-10">Loading order details...</p>;
//   }

//   if (!order) {
//     return <p className="text-center mt-10">Order not found</p>;
//   }

//   const totalQuantity = order.items.reduce(
//     (sum, item) => sum + item.quantity,
//     0
//   );


//   return (
//     <div className="">
//       <div className="">
//         {/* Bread crumb */}
//         <div className="mb-4">
//           <Breadcrumb items={breadcrumbItems} />
//         </div>

//         <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6">

//           {/* LEFT */}
//           <div className="space-y-6">
//             {/* HEADER CARD */}
//             <div className="bg-white border border-[#B5CAFF] rounded-md p-4 flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-[#191C1F]">
//                   #{order._id.slice(-8)}
//                 </p>
//                 <p className="text-xs text-[#475156]">
//                   {order.items.length} Products · Order placed on{" "}
//                   {formatOrderDate(order.createdAt)}
//                 </p>
//               </div>

//               <div className="text-[#007BFF] font-bold text-lg md:text-xl">
//                 ₹{order.totalAmount}
//               </div>

//               {/* <img
//               src={order.items[0].variantId.images[0]}
//               className="w-12 h-12 rounded border-2 border-[#B5CAFF] object-cover"
//               alt=""
//             /> */}
//             </div>

//             <div className="bg-white border rounded-md p-4 space-y-6">
//               {order.items.map((item) => (
//                 <div key={item._id} className="border-b pb-6 last:border-none">
//                   <div className="flex flex-col xl:flex-row xl:items-center gap-4">

//                     {/* LEFT: PRODUCT INFO */}
//                     <div className="flex gap-4 flex-1">
//                       <img
//                         src={item.variantId.images[0]}
//                         className="w-16 h-20 object-cover rounded border"
//                         alt=""
//                       />

//                       <div>
//                         <p className="text-sm font-medium">
//                           {item.productId.productName}
//                         </p>

//                         <p className="text-xs text-gray-500">
//                           Color: {item.variantId.colorName} | Size: {item.sizeId.size}
//                         </p>

//                         <p className="flex flex-row text-sm font-semibold mt-1">
//                           ₹{item.price} <X strokeWidth={2} size={16} className="mt-0.5 text-black" /> {item.quantity}
//                         </p>
//                       </div>
//                     </div>

//                     {/* RIGHT: REVIEW ACTION */}
//                     <div className="xl:w-[140px] xl:text-right">
//                       {!reviewFetchedMap[item.productId._id] ? (
//                         <span className="text-xs text-gray-400">Checking review...</span>
//                       ) : reviewsMap[item.productId._id] ? (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium"
//                         >
//                           View Review
//                         </button>
//                       ) : (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium"
//                         >
//                           Add Review
//                         </button>
//                       )}
//                     </div>

//                   </div>
//                 </div>

//               ))}
//             </div>
//             <OrderActivity />

//           </div>

//           {/* RIGHT */}
//           <div className="space-y-6">
//             <div className="bg-white rounded-md border border-[#E4E7E9] p-4">
//               <h2 className="text-base md:text-lg font-semibold mb-2">Shipping details</h2>
//               <hr />
//               <p className="text-sm leading-6 mt-2">
//                 {order.shippingAddress.name} <br />
//                 {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
//                 {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
//                 {order.shippingAddress.pincode} <br />
//                 Phone: {order.shippingAddress.phone}
//               </p>
//             </div>

// <div className="bg-white rounded-md border border-[#E4E7E9] px-4 pt-4 pb-4 lg:pb-10">
//   <h2 className="text-base md:text-lg font-semibold mb-3">Order Summary</h2>

//   <div className="space-y-3 text-sm">
//     {/* Subtotal */}
//     <Row
//       label={`Subtotal (${order.items.length} items)`}
//       value={`₹${order.subtotal}`}
//     />

//     {/* Quantity */}
//     <Row
//       label="Total Quantity"
//       value={totalQuantity}
//     />

//     {/* TAX – show only if > 0 */}
//     {order.tax > 0 && (
//       <Row
//         label="Tax"
//         value={`₹${order.tax}`}
//       />
//     )}

//     {/* DELIVERY */}
//     <Row
//       label="Delivery"
//       value={
//         order.shippingOption === "Free"
//           ? "Free"
//           : `₹${order.shippingOption}`
//       }
//       green={order.shippingOption === "Free"}
//     />

//     <hr />

//     {/* TOTAL */}
//     <Row
//       label="Total"
//       value={`₹${order.totalAmount}`}
//       bold
//     />
//   </div>
// </div>
//           </div>
//         </div>
//         <OrderTracker status={order.status} />

//       </div>
//       {/* <div className="mt-8 flex justify-center">
//     <button
//         onClick={() => setOpenReview(true)}
//         className="
//         w-full 
//         sm:w-auto 
//         px-8
//         bg-[#007BFF] 
//         text-white 
//         py-2 
//         rounded-md 
//         text-sm 
//         font-medium
//         "
//     >
//         Add Review & comments
//     </button>
//     </div> */}

//     <ReviewModal
//       open={openReview}
//       onClose={(newReview) => {
//         setOpenReview(false);

//         if (newReview && selectedProduct) {
//           //  instantly update UI
//           setReviewsMap(prev => ({
//             ...prev,
//             [selectedProduct]: newReview,
//           }));

//           setReviewFetchedMap(prev => ({
//             ...prev,
//             [selectedProduct]: true,
//           }));
//         } else if (selectedProduct) {
//           // fallback safety
//           fetchMyReview(selectedProduct);
//         }
//       }}
//       productId={selectedProduct}
//       existingReview={reviewsMap[selectedProduct]}
//     />
//     </div>
//   );
// };

// export default OrderDetailsPage;


// import React, { useCallback, useEffect, useState } from "react";
// import ReviewModal from "./ReviewModal";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { useParams } from "react-router-dom";
// import { X, ChevronDown, ChevronUp } from "lucide-react";
// import Breadcrumb from "../BreadCrumb";

// const formatOrderDate = (dateString) => {
//   const date = new Date(dateString);

//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, "0");

//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   hours = String(hours).padStart(2, "0");

//   return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
// };

// // Status configuration
// const statusConfig = {
//   pending: {
//     label: "Pending",
//     icon: "clock",
//     color: "yellow",
//     description: "Order is pending"
//   },
//   ordered: {
//     label: "Order Placed",
//     icon: "clipboard",
//     color: "blue",
//     description: "Your order has been placed successfully"
//   },
//   packaged: {
//     label: "Packaged",
//     icon: "package",
//     color: "blue",
//     description: "Your order has been packaged and ready for shipment"
//   },
//   shipped: {
//     label: "Shipped",
//     icon: "truck",
//     color: "blue",
//     description: "Your order has been shipped"
//   },
//   delivered: {
//     label: "Delivered",
//     icon: "home",
//     color: "green",
//     description: "Your order has been delivered successfully"
//   },
//   cancelled: {
//     label: "Cancelled",
//     icon: "x-circle",
//     color: "red",
//     description: "Your order has been cancelled"
//   },
//   returnRequested: {
//     label: "Return Requested",
//     icon: "rotate-ccw",
//     color: "orange",
//     description: "Return has been requested for this order"
//   },
//   returnAccepted: {
//     label: "Return Accepted",
//     icon: "check-circle",
//     color: "blue",
//     description: "Return request has been accepted"
//   },
//   returned: {
//     label: "Returned",
//     icon: "package-x",
//     color: "gray",
//     description: "Order has been returned successfully"
//   }
// };

// // Determine which tracking flow to show
// const getTrackingFlow = (status) => {
//   // Cancelled flow
//   if (status === "cancelled") {
//     return {
//       steps: ["ordered", "cancelled"],
//       type: "cancelled"
//     };
//   }
  
//   // Return flow
//   if (["returnRequested", "returnAccepted", "returned"].includes(status)) {
//     return {
//       steps: ["ordered", "packaged", "shipped", "delivered", status],
//       type: "return"
//     };
//   }
  
//   // Normal delivery flow
//   return {
//     steps: ["ordered", "packaged", "shipped", "delivered"],
//     type: "normal"
//   };
// };

// const getCompletedIndex = (status, steps) => {
//   const index = steps.findIndex(step => step === status);
//   return index >= 0 ? index : 0;
// };

// const IconWrapper = ({ children, active, completed, isCancelled, isReturn }) => (
//   <div className="relative flex items-center justify-center">
//     {/* PULSE RING */}
//     {active && !isCancelled && (
//       <span
//         className="absolute w-11 h-11 rounded-full bg-[#007BFF]/20 animate-ping"
//       />
//     )}

//     <div
//       className={`
//         w-10 h-10 rounded-full flex items-center justify-center
//         transition-all duration-300
//         ${isCancelled 
//           ? "border-2 border-red-500 bg-red-50"
//           : isReturn
//             ? "border-2 border-orange-500 bg-orange-50"
//             : completed
//               ? "bg-[#007BFF] shadow-md"
//               : active
//                 ? "border-2 border-[#007BFF] bg-white"
//                 : "border-2 border-[#D0DBFF] bg-white"
//         }
//       `}
//     >
//       {children}
//     </div>
//   </div>
// );

// const OrderPlacedIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="2"
//       />
//       <path
//         d="M9 12l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// const PackagingIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7l9 5 9-5-9-4-9 4z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M3 7v10l9 5 9-5V7"
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//     </svg>
//   </IconWrapper>
// );

// const OnTheRoadIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7h11v7H3z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="1"
//       />
//       <path
//         d="M14 9h4l3 3v2h-7z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//       <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//     </svg>
//   </IconWrapper>
// );

// const DeliveredIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M9 16l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// const CancelledIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={true} isCancelled={true}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <circle
//         cx="12"
//         cy="12"
//         r="9"
//         fill="none"
//         stroke="#FF4444"
//         strokeWidth="2"
//       />
//       <path
//         d="M15 9l-6 6M9 9l6 6"
//         stroke="#FF4444"
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// const ReturnIcon = ({ active, completed, label }) => (
//   <IconWrapper active={active} completed={completed} isReturn={true}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       {label === "Return Requested" && (
//         <>
//           <path
//             d="M3 9l9-7 9 7v11a1 1 0 01-1 1H4a1 1 0 01-1-1V9z"
//             fill="none"
//             stroke="#FFA500"
//             strokeWidth="2"
//           />
//           <path
//             d="M16 12H8m0 0l3-3m-3 3l3 3"
//             stroke="#FFA500"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         </>
//       )}
//       {label === "Return Accepted" && (
//         <>
//           <circle
//             cx="12"
//             cy="12"
//             r="9"
//             fill="none"
//             stroke="#FFA500"
//             strokeWidth="2"
//           />
//           <path
//             d="M9 12l2 2 4-4"
//             stroke="#FFA500"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         </>
//       )}
//       {label === "Returned" && (
//         <>
//           <path
//             d="M3 7l9 5 9-5-9-4-9 4z"
//             fill="none"
//             stroke="#666"
//             strokeWidth="2"
//           />
//           <path
//             d="M3 7v10l9 5 9-5V7"
//             stroke="#666"
//             strokeWidth="2"
//           />
//           <path
//             d="M12 22V12"
//             stroke="#666"
//             strokeWidth="2"
//           />
//         </>
//       )}
//     </svg>
//   </IconWrapper>
// );

// // Map status to icon component
// const statusIconMap = {
//   ordered: OrderPlacedIcon,
//   packaged: PackagingIcon,
//   shipped: OnTheRoadIcon,
//   delivered: DeliveredIcon,
//   cancelled: CancelledIcon,
//   returnRequested: ReturnIcon,
//   returnAccepted: ReturnIcon,
//   returned: ReturnIcon,
// };

// /* ===================== SMALL COMPONENTS ===================== */

// const Row = ({ label, value, bold, green }) => (
//   <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
//     <span className={green ? "text-green-600" : ""}>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* ===================== TRACKER ===================== */

// const OrderTracker = ({ status }) => {
//   const trackingFlow = getTrackingFlow(status);
//   const steps = trackingFlow.steps;
//   const completedIndex = getCompletedIndex(status, steps);
  
//   // Calculate positions for each step
//   const getStepPositions = () => {
//     if (steps.length === 2) {
//       return ['0%', '100%'];
//     }
    
//     const positions = [];
//     for (let i = 0; i < steps.length; i++) {
//       positions.push(`${(i / (steps.length - 1)) * 100}%`);
//     }
//     return positions;
//   };
  
//   const stepPositions = getStepPositions();

//   return (
//     <div className="rounded-xl p-6 mt-6 bg-white border border-[#E4E7E9]">
//       <h3 className="text-base md:text-lg px-2 font-semibold mb-4">Order Tracking</h3>
      
//       {/* Container for the whole tracker */}
//       <div className="relative">
        
//         {/* Progress Bar Section */}
//         <div className="relative h-1 mx-16 mb-12">
//           {/* Base Line */}
//           <div className="absolute inset-0 bg-gray-200 rounded-full" />
          
//           {/* Progress Line */}
//           <div
//             className={`absolute h-full rounded-full transition-all duration-700 ${
//               trackingFlow.type === 'cancelled' ? 'bg-red-500' :
//               trackingFlow.type === 'return' ? 'bg-orange-500' :
//               'bg-[#007BFF]'
//             }`}
//             style={{
//               width: `${(completedIndex / (steps.length - 1)) * 100}%`,
//             }}
//           />
          
//           {/* Step Dots - Positioned absolutely */}
//           {steps.map((stepId, i) => {
//             const isDone = i <= completedIndex;
//             const isActive = i === completedIndex;
            
//             return (
//               <div
//                 key={stepId}
//                 className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2"
//                 style={{
//                   left: stepPositions[i]
//                 }}
//               >
//                 <div
//                   className={`
//                     w-5 h-5 rounded-full
//                     flex items-center justify-center
//                     transition-all duration-700 ease-in-out
//                     ${stepId === 'cancelled' 
//                       ? 'bg-red-500 border-2 border-red-500'
//                       : ['returnRequested', 'returnAccepted', 'returned'].includes(stepId)
//                         ? isDone ? 'bg-orange-500' : 'border-2 border-orange-300 bg-white'
//                         : isDone
//                           ? 'bg-[#007BFF]'
//                           : 'border-2 border-[#007BFF] bg-white'
//                     }
//                   `}
//                   style={{
//                     transform: isActive ? 'scale(1.3)' : 'scale(1)',
//                   }}
//                 >
//                   {isDone && stepId !== 'cancelled' && !['returnRequested', 'returnAccepted', 'returned'].includes(stepId) && (
//                     <svg
//                       viewBox="0 0 24 24"
//                       className="w-3 h-3 text-white"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="3"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <polyline points="20 6 9 17 4 12" />
//                     </svg>
//                   )}
//                   {stepId === 'cancelled' && (
//                     <span className="text-white text-xs font-bold">✕</span>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Icons and Labels Section - Positioned to align with dots */}
//         <div className="relative mx-16">
//           <div className="flex justify-between items-start">
//             {steps.map((stepId, index) => {
//               const Icon = statusIconMap[stepId] || OrderPlacedIcon;
//               const config = statusConfig[stepId] || {};

//               const isCompleted = index < completedIndex;
//               const isActive = index === completedIndex;
//               const isUpcoming = index > completedIndex;

//               return (
//                 <div
//                   key={stepId}
//                   className="flex flex-col items-center gap-2"
//                   style={{
//                     position: 'absolute',
//                     left: stepPositions[index],
//                     transform: 'translateX(-50%)',
//                     minWidth: 'max-content'
//                   }}
//                 >
//                   {/* ICON */}
//                   <div className="flex items-center justify-center">
//                     <Icon
//                       completed={isCompleted}
//                       active={isActive}
//                       label={config.label}
//                     />
//                   </div>

//                   {/* LABEL */}
//                   <p
//                     className={`text-xs text-center font-medium whitespace-nowrap ${
//                       isActive 
//                         ? stepId === 'cancelled' ? 'text-red-600' :
//                           ['returnRequested', 'returnAccepted', 'returned'].includes(stepId) ? 'text-orange-600' :
//                           'text-[#007BFF]'
//                         : isUpcoming 
//                           ? 'text-gray-400' 
//                           : 'text-gray-700'
//                     }`}
//                   >
//                     {config.label || stepId}
//                   </p>
//                 </div>
//               );
//             })}
//           </div>
//           {/* Spacer to give height to the container */}
//           <div className="h-28" />
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ===================== ACTIVITY ===================== */

// const OrderActivity = ({ order }) => {
//   const [showAll, setShowAll] = useState(false);

//   // Generate activities from status history
//   const generateActivities = () => {
//     const activities = [];
    
//     // Add initial order placed activity
//     activities.push({
//       text: statusConfig.ordered.description,
//       time: formatOrderDate(order.createdAt),
//       status: 'ordered',
//       success: false
//     });

//     // Add activities from status history
//     if (order.statusHistory && order.statusHistory.length > 0) {
//       order.statusHistory.forEach(history => {
//         const config = statusConfig[history.status];
//         if (config) {
//           activities.push({
//             text: config.description,
//             time: formatOrderDate(history.updatedAt),
//             status: history.status,
//             success: history.status === 'delivered'
//           });
//         }
//       });
//     }

//     // Sort by date (newest first)
//     return activities.reverse();
//   };

//   const activities = generateActivities();
//   const displayedActivities = showAll ? activities : activities.slice(0, 5);

//   const getActivityColor = (status) => {
//     const config = statusConfig[status];
//     if (!config) return { bg: 'bg-gray-100', text: 'text-gray-600' };
    
//     const colorMap = {
//       blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
//       green: { bg: 'bg-green-100', text: 'text-green-600' },
//       red: { bg: 'bg-red-100', text: 'text-red-600' },
//       orange: { bg: 'bg-orange-100', text: 'text-orange-600' },
//       yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
//       gray: { bg: 'bg-gray-100', text: 'text-gray-600' }
//     };
    
//     return colorMap[config.color] || colorMap.gray;
//   };

//   return (
//     <div className="bg-white rounded-md border border-[#E4E7E9] p-6">
//       <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

//       <div className="space-y-4">
//         {displayedActivities.map((activity, i) => {
//           const colors = getActivityColor(activity.status);
          
//           return (
//             <div key={i} className="flex gap-4">
//               <div
//                 className={`w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 ${colors.bg} ${colors.text}`}
//               >
//                 ✓
//               </div>

//               <div className="flex-1">
//                 <p className="text-sm">{activity.text}</p>
//                 <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* View All / View Less Button */}
//       {activities.length > 5 && (
//         <button
//           onClick={() => setShowAll(!showAll)}
//           className="mt-4 w-full py-2 px-4 border border-[#007BFF] text-[#007BFF] rounded-lg hover:bg-[#007BFF] hover:text-white transition-colors duration-200 flex items-center justify-center gap-2 text-sm font-medium"
//         >
//           {showAll ? (
//             <>
//               View Less <ChevronUp size={16} />
//             </>
//           ) : (
//             <>
//               View All ({activities.length - 5} more) <ChevronDown size={16} />
//             </>
//           )}
//         </button>
//       )}
//     </div>
//   );
// };

// /* ===================== PAGE ===================== */

// const OrderDetailsPage = () => {
//   const [openReview, setOpenReview] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [reviewsMap, setReviewsMap] = useState({});
//   const [reviewFetchedMap, setReviewFetchedMap] = useState({});

//   const { orderId } = useParams();
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     const res = await api({
//       method: SummaryApi.getOrderById.method,
//       url: SummaryApi.getOrderById.url(orderId),
//     });

//     if (res.data.success) {
//       setOrder(res.data.order);
//     }
//     setLoading(false);
//   }, [orderId]);

//   useEffect(() => {
//     fetchOrder();
//   }, [fetchOrder]);

//   const fetchMyReview = useCallback(async (productId) => {
//     if (!productId || reviewFetchedMap[productId]) return;

//     try {
//       const res = await api({
//         method: SummaryApi.getMyReview.method,
//         url: SummaryApi.getMyReview.url(productId),
//       });

//       setReviewsMap(prev => ({
//         ...prev,
//         [productId]: res.data.success ? res.data.review : null,
//       }));

//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));

//     } catch (err) {
//       console.error("Fetch review error:", err);
//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));
//     }
//   }, [reviewFetchedMap]);

//   useEffect(() => {
//     if (!order) return;

//     order.items.forEach(item => {
//       fetchMyReview(item.productId._id);
//     });
//   }, [order, fetchMyReview]);

//   const breadcrumbItems = [
//     { label: "Home", path: "/" },
//     { label: "My Orders", path: "/my-account/my-orders" },
//     { label: `#${order?.razorpayOrderId || order?._id?.slice(-8)}` },
//   ];

//   if (loading) {
//     return <p className="text-center mt-10">Loading order details...</p>;
//   }

//   if (!order) {
//     return <p className="text-center mt-10">Order not found</p>;
//   }

//   const totalQuantity = order.items.reduce(
//     (sum, item) => sum + item.quantity,
//     0
//   );

//   return (
//     <div>
//       <div>
//         {/* Breadcrumb */}
//         <div className="mb-4">
//           <Breadcrumb items={breadcrumbItems} />
//         </div>

//         <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6">

//           {/* LEFT */}
//           <div className="space-y-6">
//             {/* HEADER CARD */}
//             <div className="bg-white border border-[#B5CAFF] rounded-md p-4 flex items-center justify-between">
//               <div className="flex-1">
//                 <p className="text-sm font-medium text-[#191C1F]">
//                   #{order.razorpayOrderId}
//                 </p>
//                 <p className="text-xs text-[#475156]">
//                   {order.items.length} Products · Order placed on{" "}
//                   {formatOrderDate(order.createdAt)}
//                 </p>
//               </div>

//               <div className="text-[#007BFF] font-bold text-lg md:text-xl">
//                 ₹{order.totalAmount}
//               </div>
//             </div>

//             <div className="bg-white border rounded-md p-4 space-y-6">
//               {order.items.map((item) => (
//                 <div key={item._id} className="border-b pb-6 last:border-none">
//                   <div className="flex flex-col xl:flex-row xl:items-center gap-4">

//                     {/* LEFT: PRODUCT INFO */}
//                     <div className="flex gap-4 flex-1">
//                       <img
//                         src={item.variantId.images[0]}
//                         className="w-16 h-20 object-cover rounded border"
//                         alt=""
//                       />

//                       <div className="flex-1">
//                         <p className="text-sm font-medium line-clamp-2">
//                           {item.productId.productName}
//                         </p>

//                         <p className="text-xs text-gray-500">
//                           Color: {item.variantId.colorName} | Size: {item.sizeId.size}
//                         </p>

//                         <p className="flex flex-row text-sm font-semibold mt-1">
//                           ₹{item.price} <X strokeWidth={2} size={16} className="mt-0.5 text-black" /> {item.quantity}
//                         </p>
//                       </div>
//                     </div>

//                     {/* RIGHT: REVIEW ACTION */}
//                     <div className="xl:w-[140px] xl:text-right">
//                       {!reviewFetchedMap[item.productId._id] ? (
//                         <span className="text-xs text-gray-400">Checking review...</span>
//                       ) : reviewsMap[item.productId._id] ? (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium hover:underline"
//                         >
//                           View Review
//                         </button>
//                       ) : (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium hover:underline"
//                         >
//                           Add Review
//                         </button>
//                       )}
//                     </div>

//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <OrderActivity order={order} />
//           </div>

//           {/* RIGHT */}
//           <div className="space-y-6">
//             <div className="bg-white rounded-md border border-[#E4E7E9] p-4">
//               <h2 className="text-base md:text-lg font-semibold mb-2">Shipping details</h2>
//               <hr />
//               <p className="text-sm leading-6 mt-2">
//                 {order.shippingAddress.name} <br />
//                 {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
//                 {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
//                 {order.shippingAddress.pincode} <br />
//                 Phone: {order.shippingAddress.phone}
//               </p>
//             </div>

//             <div className="bg-white rounded-md border border-[#E4E7E9] px-4 pt-4 pb-4 lg:pb-10">
//               <h2 className="text-base md:text-lg font-semibold mb-3">Order Summary</h2>

//               <div className="space-y-3 text-sm">
//                 {/* Subtotal */}
//                 <Row
//                   label={`Subtotal (${order.items.length} items)`}
//                   value={`₹${order.subtotal}`}
//                 />

//                 {/* Quantity */}
//                 <Row
//                   label="Total Quantity"
//                   value={totalQuantity}
//                 />

//                 {/* TAX – show only if > 0 */}
//                 {order.tax > 0 && (
//                   <Row
//                     label="Tax"
//                     value={`₹${order.tax}`}
//                   />
//                 )}

//                 {/* DELIVERY */}
//                 <Row
//                   label="Delivery"
//                   value={
//                     order.shippingOption === "Free"
//                       ? "Free"
//                       : `₹${order.shippingOption}`
//                   }
//                   green={order.shippingOption === "Free"}
//                 />

//                 <hr />

//                 {/* TOTAL */}
//                 <Row
//                   label="Total"
//                   value={`₹${order.totalAmount}`}
//                   bold
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
        
//         <OrderTracker status={order.status} />
//       </div>
      
//       <ReviewModal
//         open={openReview}
//         onClose={(newReview) => {
//           setOpenReview(false);

//           if (newReview && selectedProduct) {
//             setReviewsMap(prev => ({
//               ...prev,
//               [selectedProduct]: newReview,
//             }));

//             setReviewFetchedMap(prev => ({
//               ...prev,
//               [selectedProduct]: true,
//             }));
//           } else if (selectedProduct) {
//             fetchMyReview(selectedProduct);
//           }
//         }}
//         productId={selectedProduct}
//         existingReview={reviewsMap[selectedProduct]}
//       />
//     </div>
//   );
// };

// export default OrderDetailsPage;


import React, { useCallback, useEffect, useState } from "react";
import ReviewModal from "./ReviewModal";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { useParams } from "react-router-dom";
import { X, ChevronDown, ChevronUp, AlertTriangle, Package } from "lucide-react";
import Breadcrumb from "../BreadCrumb";
import { createPortal } from "react-dom";
import { toast } from "react-hot-toast";

const formatOrderDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
};

// Status configuration
const statusConfig = {
  pending: {
    label: "Pending",
    icon: "clock",
    color: "yellow",
    description: "Order is pending"
  },
  ordered: {
    label: "Order Placed",
    icon: "clipboard",
    color: "blue",
    description: "Your order has been placed successfully"
  },
  packaged: {
    label: "Packaged",
    icon: "package",
    color: "blue",
    description: "Your order has been packaged and ready for shipment"
  },
  shipped: {
    label: "Shipped",
    icon: "truck",
    color: "blue",
    description: "Your order has been shipped"
  },
  delivered: {
    label: "Delivered",
    icon: "home",
    color: "green",
    description: "Your order has been delivered successfully"
  },
  cancelled: {
    label: "Cancelled",
    icon: "x-circle",
    color: "red",
    description: "Your order has been cancelled"
  },
  returnRequested: {
    label: "Return Requested",
    icon: "rotate-ccw",
    color: "orange",
    description: "Return has been requested for this order"
  },
  returnAccepted: {
    label: "Return Accepted",
    icon: "check-circle",
    color: "blue",
    description: "Return request has been accepted"
  },
  returned: {
    label: "Returned",
    icon: "package-x",
    color: "gray",
    description: "Order has been returned successfully"
  }
};

// Cancel Modal Component
const CancelOrderModal = ({ open, onClose, onConfirm, loading }) => {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const cancelReasons = [
    "Changed my mind",
    "Found a better price elsewhere",
    "Ordered by mistake",
    "Product not required anymore",
    "Other"
  ];

  const handleSubmit = () => {
    const finalReason = reason === "Other" ? otherReason : reason;
    if (!finalReason.trim()) {
      toast.error("Please provide a reason for cancellation");
      return;
    }
    onConfirm(finalReason);
  };

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center px-4 z-[9999]"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-xl border-2 border-red-500 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b bg-red-50 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertTriangle className="text-red-600" size={24} />
            <h2 className="font-semibold text-lg">Cancel Order</h2>
          </div>
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          <p className="text-sm text-gray-600">
            Are you sure you want to cancel this order? This action cannot be undone.
          </p>

          <div>
            <p className="text-sm font-medium mb-3">Reason for cancellation</p>
            <div className="space-y-2">
              {cancelReasons.map((r) => (
                <label key={r} className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="reason"
                    value={r}
                    checked={reason === r}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-4 h-4 text-red-600"
                  />
                  <span className="text-sm">{r}</span>
                </label>
              ))}
            </div>

            {reason === "Other" && (
              <textarea
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                placeholder="Please specify your reason"
                className="mt-3 w-full h-20 border rounded-md px-3 py-2 text-sm outline-none focus:border-red-500"
              />
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-lg text-sm font-medium hover:bg-gray-100"
          >
            Keep Order
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !reason}
            className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 disabled:opacity-50"
          >
            {loading ? "Cancelling..." : "Cancel Order"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

// Return Modal Component
const ReturnOrderModal = ({ open, onClose, onConfirm, loading, order }) => {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  // const [selectedItems, setSelectedItems] = useState([]);
  const [images, setImages] = useState([]);

  const returnReasons = [
    "Product damaged",
    "Wrong product delivered",
    "Product not as described",
    "Quality not satisfactory",
    "Size/Fit issues",
    "Other"
  ];

  // useEffect(() => {
  //   if (open && order) {
  //     // Select all items by default
  //     setSelectedItems(order.items.map(item => item._id));
  //   }
  // }, [open, order]);

  // const handleItemToggle = (itemId) => {
  //   setSelectedItems(prev => 
  //     prev.includes(itemId) 
  //       ? prev.filter(id => id !== itemId)
  //       : [...prev, itemId]
  //   );
  // };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length + images.length > 3) {
      toast.error("Maximum 3 images allowed");
      return;
    }
    setImages(prev => [...prev, ...files]);
  };

  const removeImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    const finalReason = reason === "Other" ? otherReason : reason;
    if (!finalReason.trim()) {
      toast.error("Please provide a reason for return");
      return;
    }
    // if (selectedItems.length === 0) {
    //   toast.error("Please select at least one item to return");
    //   return;
    // }
    onConfirm({
      reason: finalReason,
      images
    });
  };

  if (!open || !order) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center px-4 z-[9999]"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-2xl rounded-xl border-2 border-orange-500 overflow-hidden max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b bg-orange-50 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Package className="text-orange-600" size={24} />
            <h2 className="font-semibold text-lg">Return Request</h2>
          </div>
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-5 overflow-y-auto">
          {/* Select Items */}
          <div>
            <p className="text-sm font-medium mb-3">All items to return</p>
            <div className="space-y-3">
              {order.items.map((item) => (
                <label key={item._id} className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
                  {/* <input
                    type="checkbox"
                    checked={selectedItems.includes(item._id)}
                    onChange={() => handleItemToggle(item._id)}
                    className="mt-1"
                  /> */}
                  <img
                    src={item.variantId.images[0]}
                    alt=""
                    className="w-16 h-16 object-cover rounded"
                  />
                  <div className="flex-1">
                    <p className="text-sm font-medium line-clamp-1">
                      {item.productId.productName}
                    </p>
                    <p className="text-xs text-gray-500">
                      {item.variantId.colorName} | Size: {item.sizeId.size}
                    </p>
                    <p className="text-sm font-semibold">₹{item.price} × {item.quantity}</p>
                  </div>
                </label>
              ))}
            </div>
          </div>

          {/* Reason */}
          <div>
            <p className="text-sm font-medium mb-3">Reason for return</p>
            <div className="space-y-2">
              {returnReasons.map((r) => (
                <label key={r} className="flex items-center gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="returnReason"
                    value={r}
                    checked={reason === r}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-4 h-4 text-orange-600"
                  />
                  <span className="text-sm">{r}</span>
                </label>
              ))}
            </div>

            {reason === "Other" && (
              <textarea
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                placeholder="Please specify your reason"
                className="mt-3 w-full h-20 border rounded-md px-3 py-2 text-sm outline-none focus:border-orange-500"
              />
            )}
          </div>

          {/* Image Upload */}
          <div>
            <p className="text-sm font-medium mb-3">Upload images (Optional)</p>
            <p className="text-xs text-gray-500 mb-2">Upload up to 3 images of the product</p>
            
            <div className="flex gap-3 flex-wrap">
              {images.map((img, index) => (
                <div key={index} className="relative">
                  <img
                    src={URL.createObjectURL(img)}
                    alt=""
                    className="w-20 h-20 object-cover rounded border"
                  />
                  <button
                    onClick={() => removeImage(index)}
                    className="absolute -top-2 -right-2 bg-white border rounded-full w-6 h-6 flex items-center justify-center shadow hover:bg-red-50"
                  >
                    <X size={14} className="text-red-500" />
                  </button>
                </div>
              ))}
              
              {images.length < 3 && (
                <label className="w-20 h-20 border-2 border-dashed border-gray-300 rounded flex items-center justify-center cursor-pointer hover:border-orange-500">
                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                  <span className="text-gray-400 text-2xl">+</span>
                </label>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-lg text-sm font-medium hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !reason}
            className="px-4 py-2 bg-orange-600 text-white rounded-lg text-sm font-medium hover:bg-orange-700 disabled:opacity-50"
          >
            {loading ? "Submitting..." : "Submit Return Request"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

// Helper functions
const canCancelOrder = (order) => {
  const cancellableStatuses = ["pending", "ordered", "packaged"];
  return cancellableStatuses.includes(order.status) && 
         !["cancelled", "returnRequested", "returnAccepted", "returned"].includes(order.status);
};

const canReturnOrder = (order) => {
  if (order.status !== "delivered") return false;
  
  // Find the delivered status from history
  const deliveredStatus = order.statusHistory
    ?.filter(h => h.status === "delivered")
    ?.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
  
  if (!deliveredStatus) return false;
  
  // Check if within 7 days
  const deliveredDate = new Date(deliveredStatus.updatedAt);
  const currentDate = new Date();
  const daysDiff = Math.floor((currentDate - deliveredDate) / (1000 * 60 * 60 * 24));
  
  return daysDiff <= 7;
};

// ... (keep all the existing status configuration, icon components, and other code)

// Determine which tracking flow to show
const getTrackingFlow = (status) => {
  // Cancelled flow
  if (status === "cancelled") {
    return {
      steps: ["ordered", "cancelled"],
      type: "cancelled"
    };
  }
  
  // Return flow
  if (["returnRequested", "returnAccepted", "returned"].includes(status)) {
    return {
      steps: ["ordered", "packaged", "shipped", "delivered", status],
      type: "return"
    };
  }
  
  // Normal delivery flow
  return {
    steps: ["ordered", "packaged", "shipped", "delivered"],
    type: "normal"
  };
};

const getCompletedIndex = (status, steps) => {
  const index = steps.findIndex(step => step === status);
  return index >= 0 ? index : 0;
};

const IconWrapper = ({ children, active, completed, isCancelled, isReturn }) => (
  <div className="relative flex items-center justify-center">
    {/* PULSE RING */}
    {active && !isCancelled && (
      <span
        className="absolute w-11 h-11 rounded-full bg-[#007BFF]/20 animate-ping"
      />
    )}

    <div
      className={`
        w-10 h-10 rounded-full flex items-center justify-center
        transition-all duration-300
        ${isCancelled 
          ? "border-2 border-red-500 bg-red-50"
          : isReturn
            ? "border-2 border-orange-500 bg-orange-50"
            : completed
              ? "bg-[#007BFF] shadow-md"
              : active
                ? "border-2 border-[#007BFF] bg-white"
                : "border-2 border-[#D0DBFF] bg-white"
        }
      `}
    >
      {children}
    </div>
  </div>
);

const OrderPlacedIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path
        d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
        rx="2"
      />
      <path
        d="M9 12l2 2 4-4"
        stroke={completed ? "#007BFF" : "#007BFF"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </IconWrapper>
);

const PackagingIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path
        d="M3 7l9 5 9-5-9-4-9 4z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
      <path
        d="M3 7v10l9 5 9-5V7"
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
    </svg>
  </IconWrapper>
);

const OnTheRoadIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path
        d="M3 7h11v7H3z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
        rx="1"
      />
      <path
        d="M14 9h4l3 3v2h-7z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
      <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
      <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
    </svg>
  </IconWrapper>
);

const DeliveredIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path
        d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
      <path
        d="M9 16l2 2 4-4"
        stroke={completed ? "#007BFF" : "#007BFF"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </IconWrapper>
);

const CancelledIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={true} isCancelled={true}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="#FF4444"
        strokeWidth="2"
      />
      <path
        d="M15 9l-6 6M9 9l6 6"
        stroke="#FF4444"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </IconWrapper>
);

const ReturnIcon = ({ active, completed, label }) => (
  <IconWrapper active={active} completed={completed} isReturn={true}>
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      {label === "Return Requested" && (
        <>
          <path
            d="M3 9l9-7 9 7v11a1 1 0 01-1 1H4a1 1 0 01-1-1V9z"
            fill="none"
            stroke="#FFA500"
            strokeWidth="2"
          />
          <path
            d="M16 12H8m0 0l3-3m-3 3l3 3"
            stroke="#FFA500"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
      {label === "Return Accepted" && (
        <>
          <circle
            cx="12"
            cy="12"
            r="9"
            fill="none"
            stroke="#FFA500"
            strokeWidth="2"
          />
          <path
            d="M9 12l2 2 4-4"
            stroke="#FFA500"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
      {label === "Returned" && (
        <>
          <path
            d="M3 7l9 5 9-5-9-4-9 4z"
            fill="none"
            stroke="#666"
            strokeWidth="2"
          />
          <path
            d="M3 7v10l9 5 9-5V7"
            stroke="#666"
            strokeWidth="2"
          />
          <path
            d="M12 22V12"
            stroke="#666"
            strokeWidth="2"
          />
        </>
      )}
    </svg>
  </IconWrapper>
);

// Map status to icon component
const statusIconMap = {
  ordered: OrderPlacedIcon,
  packaged: PackagingIcon,
  shipped: OnTheRoadIcon,
  delivered: DeliveredIcon,
  cancelled: CancelledIcon,
  returnRequested: ReturnIcon,
  returnAccepted: ReturnIcon,
  returned: ReturnIcon,
};

/* ===================== SMALL COMPONENTS ===================== */

const Row = ({ label, value, bold, green }) => (
  <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
    <span className={green ? "text-green-600" : ""}>{label}</span>
    <span>{value}</span>
  </div>
);

/* ===================== TRACKER ===================== */

const OrderTracker = ({ status }) => {
  const trackingFlow = getTrackingFlow(status);
  const steps = trackingFlow.steps;
  const completedIndex = getCompletedIndex(status, steps);
  
  // Calculate positions for each step
  const getStepPositions = () => {
    if (steps.length === 2) {
      return ['0%', '100%'];
    }
    
    const positions = [];
    for (let i = 0; i < steps.length; i++) {
      positions.push(`${(i / (steps.length - 1)) * 100}%`);
    }
    return positions;
  };
  
  const stepPositions = getStepPositions();

  return (
    <div className="rounded-xl p-6 mt-6 bg-white border border-[#E4E7E9]">
      <h3 className="text-base md:text-lg px-2 font-semibold mb-6">Order Tracking</h3>
      
      {/* Container for the whole tracker */}
      <div className="relative">
        
        {/* Progress Bar Section */}
        <div className="relative h-1 mx-4 sm:mx-16 mb-12">
          {/* Base Line */}
          <div className="absolute inset-0 bg-gray-200 rounded-full" />
          
          {/* Progress Line */}
          <div
            className={`absolute h-full rounded-full transition-all duration-700 ${
              trackingFlow.type === 'cancelled' ? 'bg-red-500' :
              trackingFlow.type === 'return' ? 'bg-orange-500' :
              'bg-[#007BFF]'
            }`}
            style={{
              width: `${(completedIndex / (steps.length - 1)) * 100}%`,
            }}
          />
          
          {/* Step Dots - Positioned absolutely */}
          {steps.map((stepId, i) => {
            const isDone = i <= completedIndex;
            const isActive = i === completedIndex;
            
            return (
              <div
                key={stepId}
                className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2"
                style={{
                  left: stepPositions[i]
                }}
              >
                <div
                  className={`
                    w-5 h-5 rounded-full
                    flex items-center justify-center
                    transition-all duration-700 ease-in-out
                    ${stepId === 'cancelled' 
                      ? 'bg-red-500 border-2 border-red-500'
                      : ['returnRequested', 'returnAccepted', 'returned'].includes(stepId)
                        ? isDone ? 'bg-orange-500' : 'border-2 border-orange-300 bg-white'
                        : isDone
                          ? 'bg-[#007BFF]'
                          : 'border-2 border-[#007BFF] bg-white'
                    }
                  `}
                  style={{
                    transform: isActive ? 'scale(1.3)' : 'scale(1)',
                  }}
                >
                  {isDone && stepId !== 'cancelled' && !['returnRequested', 'returnAccepted', 'returned'].includes(stepId) && (
                    <svg
                      viewBox="0 0 24 24"
                      className="w-3 h-3 text-white"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                  {stepId === 'cancelled' && (
                    <span className="text-white text-xs font-bold">✕</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Icons and Labels Section - Positioned to align with dots */}
        <div className="relative mx-4 sm:mx-16">
          <div className="flex justify-between items-start">
            {steps.map((stepId, index) => {
              const Icon = statusIconMap[stepId] || OrderPlacedIcon;
              const config = statusConfig[stepId] || {};

              const isCompleted = index < completedIndex;
              const isActive = index === completedIndex;
              const isUpcoming = index > completedIndex;

              return (
                <div
                  key={stepId}
                  className="flex flex-col items-center gap-2"
                  style={{
                    position: 'absolute',
                    left: stepPositions[index],
                    transform: 'translateX(-50%)',
                    minWidth: 'max-content'
                  }}
                >
                  {/* ICON */}
                  <div className="flex items-center justify-center">
                    <Icon
                      completed={isCompleted}
                      active={isActive}
                      label={config.label}
                    />
                  </div>

                  {/* LABEL */}
                  <p
                    className={`text-xs text-center font-medium whitespace-nowrap ${
                      isActive 
                        ? stepId === 'cancelled' ? 'text-red-600' :
                          ['returnRequested', 'returnAccepted', 'returned'].includes(stepId) ? 'text-orange-600' :
                          'text-[#007BFF]'
                        : isUpcoming 
                          ? 'text-gray-400' 
                          : 'text-gray-700'
                    }`}
                  >
                    {config.label || stepId}
                  </p>
                </div>
              );
            })}
          </div>
          {/* Spacer to give height to the container */}
          <div className="h-28" />
        </div>
      </div>
    </div>
  );
};

/* ===================== ACTIVITY ===================== */

const OrderActivity = ({ order }) => {
  const [showAll, setShowAll] = useState(false);

  // Generate activities from status history
  const generateActivities = () => {
    const activities = [];
    
    // Add initial order placed activity
    activities.push({
      text: statusConfig.ordered.description,
      time: formatOrderDate(order.createdAt),
      status: 'ordered',
      success: false
    });

    // Add activities from status history
    if (order.statusHistory && order.statusHistory.length > 0) {
      order.statusHistory.forEach(history => {
        const config = statusConfig[history.status];
        if (config) {
          activities.push({
            text: config.description,
            time: formatOrderDate(history.updatedAt),
            status: history.status,
            success: history.status === 'delivered'
          });
        }
      });
    }

    // Sort by date (newest first)
    return activities.reverse();
  };

  const activities = generateActivities();
  const displayedActivities = showAll ? activities : activities.slice(0, 5);

  const getActivityColor = (status) => {
    const config = statusConfig[status];
    if (!config) return { bg: 'bg-gray-100', text: 'text-gray-600' };
    
    const colorMap = {
      blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
      green: { bg: 'bg-green-100', text: 'text-green-600' },
      red: { bg: 'bg-red-100', text: 'text-red-600' },
      orange: { bg: 'bg-orange-100', text: 'text-orange-600' },
      yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
      gray: { bg: 'bg-gray-100', text: 'text-gray-600' }
    };
    
    return colorMap[config.color] || colorMap.gray;
  };

  return (
    <div className="bg-white rounded-md border border-[#E4E7E9] p-6">
      <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

      <div className="space-y-4">
        {displayedActivities.map((activity, i) => {
          const colors = getActivityColor(activity.status);
          
          return (
            <div key={i} className="flex gap-4">
              <div
                className={`w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 ${colors.bg} ${colors.text}`}
              >
                ✓
              </div>

              <div className="flex-1">
                <p className="text-sm">{activity.text}</p>
                <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* View All / View Less Button */}
      {activities.length > 5 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="mt-4 w-full py-2 px-4 border border-[#007BFF] text-[#007BFF] rounded-lg hover:bg-[#007BFF] hover:text-white transition-colors duration-200 flex items-center justify-center gap-2 text-sm font-medium"
        >
          {showAll ? (
            <>
              View Less <ChevronUp size={16} />
            </>
          ) : (
            <>
              View All ({activities.length - 5} more) <ChevronDown size={16} />
            </>
          )}
        </button>
      )}
    </div>
  );
};

/* ===================== PAGE ===================== */

const OrderDetailsPage = () => {
  const [openReview, setOpenReview] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [reviewsMap, setReviewsMap] = useState({});
  const [reviewFetchedMap, setReviewFetchedMap] = useState({});
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openReturnModal, setOpenReturnModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOrder = useCallback(async () => {
    setLoading(true);
    const res = await api({
      method: SummaryApi.getOrderById.method,
      url: SummaryApi.getOrderById.url(orderId),
    });

    if (res.data.success) {
      setOrder(res.data.order);
    }
    setLoading(false);
  }, [orderId]);

  useEffect(() => {
    fetchOrder();
  }, [fetchOrder]);

  const fetchMyReview = useCallback(async (productId) => {
    if (!productId || reviewFetchedMap[productId]) return;

    try {
      const res = await api({
        method: SummaryApi.getMyReview.method,
        url: SummaryApi.getMyReview.url(productId),
      });

      setReviewsMap(prev => ({
        ...prev,
        [productId]: res.data.success ? res.data.review : null,
      }));

      setReviewFetchedMap(prev => ({
        ...prev,
        [productId]: true,
      }));

    } catch (err) {
      console.error("Fetch review error:", err);
      setReviewFetchedMap(prev => ({
        ...prev,
        [productId]: true,
      }));
    }
  }, [reviewFetchedMap]);

  useEffect(() => {
    if (!order) return;

    order.items.forEach(item => {
      fetchMyReview(item.productId._id);
    });
  }, [order, fetchMyReview]);

  const handleCancelOrder = async (reason) => {
    try {
      setActionLoading(true);

      const res = await api({
        method: SummaryApi.cancelOrder.method,
        url: SummaryApi.cancelOrder.url,
        data: {
          orderId: order._id,
          reason,
        },
      });

      if (res.data.success) {
        toast.success(res.data.message || "Order cancelled successfully");
        setOpenCancelModal(false);
        fetchOrder();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to cancel order");
    } finally {
      setActionLoading(false);
    }
  };


  const handleReturnRequest = async (returnData) => {
    try {
      setActionLoading(true);

      const formData = new FormData();
      formData.append("orderId", order._id);
      formData.append("reason", returnData.reason);

      returnData.images.forEach((img) => {
        formData.append("images", img);
      });

      const res = await api({
        method: SummaryApi.requestReturnOrder.method,
        url: SummaryApi.requestReturnOrder.url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        toast.success(res.data.message || "Return request submitted");
        setOpenReturnModal(false);
        fetchOrder();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to submit return request");
    } finally {
      setActionLoading(false);
    }
  };

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "My Orders", path: "/my-account/my-orders" },
    { label: `#${order?.razorpayOrderId || order?._id?.slice(-8)}` },
  ];

  if (loading) {
    return <p className="text-center mt-10">Loading order details...</p>;
  }

  if (!order) {
    return <p className="text-center mt-10">Order not found</p>;
  }

  const totalQuantity = order.items.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  const showCancelButton = canCancelOrder(order);
  const showReturnButton = canReturnOrder(order);

  return (
    <div>
      <div>
        {/* Breadcrumb */}
        <div className="mb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>

        <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6">

          {/* LEFT */}
          <div className="space-y-6">
            {/* HEADER CARD */}
            <div className="bg-white border border-[#B5CAFF] rounded-md p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex-1">
                  <p className="text-sm font-medium text-[#191C1F]">
                    #{order.razorpayOrderId}
                  </p>
                  <p className="text-xs text-[#475156]">
                    {order.items.length} Products · Order placed on{" "}
                    {formatOrderDate(order.createdAt)}
                  </p>
                </div>

                <div className="text-[#007BFF] font-bold text-lg md:text-xl">
                  ₹{order.totalAmount}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 pt-3 border-t">
                {showCancelButton && (
                  <button
                    onClick={() => setOpenCancelModal(true)}
                    className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 transition-colors"
                  >
                    Cancel Order
                  </button>
                )}
                
                {showReturnButton && (
                  <button
                    onClick={() => setOpenReturnModal(true)}
                    className="px-4 py-2 bg-orange-600 text-white rounded-lg text-sm font-medium hover:bg-orange-700 transition-colors"
                  >
                    Return Order
                  </button>
                )}

                {/* Show status badge if order is cancelled or returned */}
                {order.status === "cancelled" && (
                  <div className="ml-auto px-3 py-1.5 bg-red-100 text-red-700 rounded-full text-xs font-medium">
                    Order Cancelled
                  </div>
                )}
                
                {["returnRequested", "returnAccepted", "returned"].includes(order.status) && (
                  <div className="ml-auto px-3 py-1.5 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">
                    {statusConfig[order.status].label}
                  </div>
                )}
              </div>
            </div>

            <div className="bg-white border rounded-md p-4 space-y-6">
              {order.items.map((item) => (
                <div key={item._id} className="border-b pb-6 last:border-none">
                  <div className="flex flex-col xl:flex-row xl:items-center gap-4">

                    {/* LEFT: PRODUCT INFO */}
                    <div className="flex gap-4 flex-1">
                      <img
                        src={item.variantId.images[0]}
                        className="w-16 h-20 object-cover rounded border"
                        alt=""
                      />

                      <div className="flex-1">
                        <p className="text-sm font-medium line-clamp-2">
                          {item.productId.productName}
                        </p>

                        <p className="text-xs text-gray-500">
                          Color: {item.variantId.colorName} | Size: {item.sizeId.size}
                        </p>

                        <p className="flex flex-row text-sm font-semibold mt-1">
                          ₹{item.price} <X strokeWidth={2} size={16} className="mt-0.5 text-black" /> {item.quantity}
                        </p>
                      </div>
                    </div>

                    {/* RIGHT: REVIEW ACTION */}
                    <div className="xl:w-[140px] xl:text-right">
                      {/* Only show review options for delivered orders */}
                      {order.status === "delivered" && (
                        <>
                          {!reviewFetchedMap[item.productId._id] ? (
                            <span className="text-xs text-gray-400">Checking review...</span>
                          ) : reviewsMap[item.productId._id] ? (
                            <button
                              onClick={() => {
                                setSelectedProduct(item.productId._id);
                                setOpenReview(true);
                              }}
                              className="text-sm text-[#007BFF] font-medium hover:underline"
                            >
                              View Review
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                setSelectedProduct(item.productId._id);
                                setOpenReview(true);
                              }}
                              className="text-sm text-[#007BFF] font-medium hover:underline"
                            >
                              Add Review
                            </button>
                          )}
                        </>
                      )}
                    </div>

                  </div>
                </div>
              ))}
            </div>
            
            <OrderActivity order={order} />
          </div>

          {/* RIGHT */}
          <div className="space-y-6">
            <div className="bg-white rounded-md border border-[#E4E7E9] p-4">
              <h2 className="text-base md:text-lg font-semibold mb-2">Shipping details</h2>
              <hr />
              <p className="text-sm leading-6 mt-2">
                {order.shippingAddress.name} <br />
                {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
                {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
                {order.shippingAddress.pincode} <br />
                Phone: {order.shippingAddress.phone}
              </p>
            </div>

            <div className="bg-white rounded-md border border-[#E4E7E9] px-4 pt-4 pb-4 lg:pb-10">
              <h2 className="text-base md:text-lg font-semibold mb-3">Order Summary</h2>

              <div className="space-y-3 text-sm">
                {/* Subtotal */}
                <Row
                  label={`Subtotal (${order.items.length} items)`}
                  value={`₹${order.subtotal}`}
                />

                {/* Quantity */}
                <Row
                  label="Total Quantity"
                  value={totalQuantity}
                />

                {/* TAX – show only if > 0 */}
                {order.tax > 0 && (
                  <Row
                    label="Tax"
                    value={`₹${order.tax}`}
                  />
                )}

                {/* DELIVERY */}
                <Row
                  label="Delivery"
                  value={
                    order.shippingOption === "Free"
                      ? "Free"
                      : `₹${order.shippingOption}`
                  }
                  green={order.shippingOption === "Free"}
                />

                {/* COUPON DISCOUNT - if applied */}
                {order.couponDiscount > 0 && (
                  <>
                    <Row
                      label={`Coupon (${order.couponCode})`}
                      value={`-₹${order.couponDiscount}`}
                      green={true}
                    />
                  </>
                )}

                <hr />

                {/* TOTAL */}
                <Row
                  label="Total"
                  value={`₹${order.totalAmount}`}
                  bold
                />
              </div>
            </div>

            {/* Return Policy Info - Show only for delivered orders within 7 days */}
            {showReturnButton && (
              <div className="bg-orange-50 border border-orange-200 rounded-md p-4">
                <h3 className="text-sm font-semibold text-orange-800 mb-2">Return Policy</h3>
                <p className="text-xs text-orange-700">
                  You can return this order within 7 days of delivery. 
                  Please ensure the product is unused and in its original packaging.
                </p>
              </div>
            )}

            {/* Cancellation Info - Show only for cancellable orders */}
            {showCancelButton && (
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                <h3 className="text-sm font-semibold text-blue-800 mb-2">Cancellation Policy</h3>
                <p className="text-xs text-blue-700">
                  You can cancel this order before it is shipped. 
                  Once shipped, cancellation is not allowed.
                </p>
              </div>
            )}
          </div>
        </div>
        
        <OrderTracker status={order.status} />
      </div>
      
      {/* Review Modal */}
      <ReviewModal
        open={openReview}
        onClose={(newReview) => {
          setOpenReview(false);

          if (newReview && selectedProduct) {
            setReviewsMap(prev => ({
              ...prev,
              [selectedProduct]: newReview,
            }));

            setReviewFetchedMap(prev => ({
              ...prev,
              [selectedProduct]: true,
            }));
          } else if (selectedProduct) {
            fetchMyReview(selectedProduct);
          }
        }}
        productId={selectedProduct}
        existingReview={reviewsMap[selectedProduct]}
      />

      {/* Cancel Order Modal */}
      <CancelOrderModal
        open={openCancelModal}
        onClose={() => setOpenCancelModal(false)}
        onConfirm={handleCancelOrder}
        loading={actionLoading}
      />

      {/* Return Order Modal */}
      <ReturnOrderModal
        open={openReturnModal}
        onClose={() => setOpenReturnModal(false)}
        onConfirm={handleReturnRequest}
        loading={actionLoading}
        order={order}
      />
    </div>
  );
};

export default OrderDetailsPage;
